// Action Types
export const FETCH_VAS_CONTROL_DATA_REQUEST = "FETCH_VAS_CONTROL_DATA_REQUEST";
export const FETCH_VAS_CONTROL_DATA_SUCCESS = "FETCH_VAS_CONTROL_DATA_SUCCESS";
export const FETCH_VAS_CONTROL_DATA_FAILURE = "FETCH_VAS_CONTROL_DATA_FAILURE";
export const FETCH_VAS_CONTROL_DATA_RESET = "FETCH_VAS_CONTROL_DATA_RESET";
// Action Creators
export const fetchVasControlDataRequest = (payload) => ({
    type: FETCH_VAS_CONTROL_DATA_REQUEST,
    payload,
});
export const fetchVasControlDataSuccess = (payload) => ({
    type: FETCH_VAS_CONTROL_DATA_SUCCESS,
    payload,
});
export const fetchVasControlDataFailure = (payload) => ({
    type: FETCH_VAS_CONTROL_DATA_FAILURE,
    payload,
});
export const fetchVasControlDataReset = () => ({
    type: FETCH_VAS_CONTROL_DATA_RESET,
});
